import React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import Dialog from 'shared/modules/common/components/atoms/Dialog';
import BadgeAppStore from 'web/assets/images/badge-apple-app-store.png';
import BadgePlayStore from 'web/assets/images/badge-google-play-store.png';
import QRCodeAppStore from 'web/assets/images/download-link-qr-code-app-store.png';
import QRCodePlayStore from 'web/assets/images/download-link-qr-code-play-store.png';
import AppStoreBadgeLinks from 'web/modules/common/components/molecules/AppStoreBadgeLinks';

type Props = {
  open?: boolean;
  onCancel?: () => void;
};

const AppDownload = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  return (
    <Dialog
      title="毎月のご請求のお支払いも、コンビニでアプリを見せるだけ。"
      titleAlignment="left"
      open={props.open}
      onCloseButtonPress={() => props.onCancel?.()}
      onBackdropPress={() => props.onCancel?.()}
      style={style.dialog}
      id="app-download-link-dialog"
    >
      <Text style={style.text}>
        アプリから本人確認すると、3・6・12回あと払いやペイディカードなど便利な機能をご利用いただけます。アプリのダウンロードはこちら。
      </Text>
      <View style={style.qrCodeWrapper}>
        {isBigScreen ? (
          <View style={style.row}>
            <View style={style.col}>
              <TouchableOpacity
                accessibilityRole="link"
                href="https://apps.apple.com/jp/app/paidy/id1220373112"
                hrefAttrs={{
                  target: '_blank',
                }}
              >
                <Image source={{ uri: BadgeAppStore }} style={style.badge} />
              </TouchableOpacity>
              <Image source={{ uri: QRCodeAppStore }} style={style.qrCode} />
            </View>
            <View style={style.col}>
              <TouchableOpacity
                accessibilityRole="link"
                href="https://play.google.com/store/apps/details?id=com.paidy.paidy&amp;hl=ja"
                hrefAttrs={{
                  target: '_blank',
                }}
              >
                <Image source={{ uri: BadgePlayStore }} style={style.badge} />
              </TouchableOpacity>
              <Image source={{ uri: QRCodePlayStore }} style={style.qrCode} />
            </View>
          </View>
        ) : (
          <AppStoreBadgeLinks />
        )}
      </View>
    </Dialog>
  );
};

const style = StyleSheet.create({
  dialog: {
    width: '100%',
    maxWidth: 668,
  },
  text: {
    fontSize: 12,
    marginBottom: 24,
  },
  qrCode: {
    width: 200,
    height: 200,
    marginTop: 16,
  },
  qrCodeWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginVertical: 16,
  },
  row: {
    flexDirection: 'row',
  },
  col: {
    paddingHorizontal: 48,
  },
  badge: {
    width: '100%',
    aspectRatio: 357 / 107,
    resizeMode: 'contain',
  },
});

export default AppDownload;
